import { Text } from "monday-ui-react-core";

export const GuestViewerUnauthorized = () => {
    return <div className="guest-viewer-message-container">
        <Text><p style={{ whiteSpace: "normal"}}>A viewer or guest cannot use the app.</p></Text>
    </div>;
}